<template>
  <div
    class="permanent-notification"
    v-if="notifications.length"
  >
    <v-alert
      v-for="(notification, index) in notifications"
      :key="index"
      :value="true"
      :type="notification.type"
    >
      <div
        v-for="(item, i) in notification.message"
        :key="i + 1000"
      >
        {{ item }}
      </div>
    </v-alert>
  </div>
</template>

<script>
  export default {
    name: 'ThePemanentNotifications',
    computed: {
      notifications () {
        return this.$store.getters.getPermanentNotifications
      }
    }
  }
</script>

<style scoped>

</style>
